import React from "react";
import BottomSheet from "src/components/app/BottomSheet";
import AddMedicationFormContent from "src/components/app/modals/medication/AddMedicationFormContent";

interface AddMedicationBottomSheetProps {
  show: boolean;
  handleClose: () => void;
  onSuccess?: () => void;
}

const AddMedicationBottomSheet: React.FC<AddMedicationBottomSheetProps> = ({
  show,
  handleClose,
  onSuccess,
}) => {
  const handleSuccess = () => {
    onSuccess?.();
    handleClose();
  };

  return (
    <BottomSheet
      show={show}
      handleClose={handleClose}
      title="Add New Medication"
      showCloseButton
    >
      <div className="px-4 pb-6">
        <AddMedicationFormContent
          onSuccess={handleSuccess}
          handleClose={handleClose}
        />
      </div>
    </BottomSheet>
  );
};

export default AddMedicationBottomSheet;
